if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      if (this.priceObserver) {
        this.priceObserver.disconnect();
        this.priceObserver = null;
      }
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      if (opener.querySelector('.loading-overlay__spinner')) {
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          if (!this.productElement) {
            window.location.href = opener.getAttribute('data-product-url');
            return;
          }

          this.preventDuplicatedIDs();
          this.cleanUnwantedElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          
          this.buildGallery();
          this.buildEyebrowAndBadges();
          this.buildActionButtons();
          this.buildTrustAndRating();
          this.preventVariantURLSwitching();
          this.setupBuyNow();

          if (typeof DTWishlist === 'function') {
            DTWishlist();
          }

          super.show(opener);
        })
        .catch((err) => {
          console.error('Quick Add Error:', err);
          window.location.href = opener.getAttribute('data-product-url');
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (opener.querySelector('.loading-overlay__spinner')) {
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    cleanUnwantedElements() {
      const selectorsToRemove = [
        'pickup-availability',
        'product-modal',
        'enquiryPopUp',
        'modal-dialog',
        '#dT_bundleSelector',
        '.product__info-as-bottom-tabs',
        '.breadcrumb-main-template',
        '.rating-fake-sales',
        '.social-proof-sales',
        '.product__accordion',
        '.icon-with-text',
        '.product__inventory',
        '.product-attributes',
        '.dt-sc-enquiry-form',
        '.prev-next-product-navigation',
        'aside',
        '.quick-add-hidden',
        '.product__tax',
        '.price__tax-note',
        '.tax-note',
        '.product-form__buy-now',
        '.shopify-payment-button'
      ];
      selectorsToRemove.forEach((sel) => {
        this.productElement.querySelectorAll(sel).forEach((el) => el.remove());
      });
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      if (sectionId) {
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
          variantSelect.dataset.originalSection = sectionId;
        });
      }
    }

    buildGallery() {
      const mediaWrapper = this.modalContent.querySelector('.product__media-wrapper');
      if (!mediaWrapper) return;

      const mediaItems = Array.from(this.modalContent.querySelectorAll('.product__media-list > li, .product__media-item, .media-gallery .product__media'));
      const imageSources = [];

      mediaItems.forEach((item) => {
        const img = item.querySelector('img');
        if (img && img.src) {
          const src = img.src;
          const alt = img.alt || 'Product image';
          if (!imageSources.some((s) => s.src === src)) {
            imageSources.push({ src, alt, mediaId: item.dataset.mediaId || '' });
          }
        }
      });

      if (imageSources.length === 0) {
        const anyImg = mediaWrapper.querySelector('img');
        if (anyImg && anyImg.src) {
          imageSources.push({ src: anyImg.src, alt: anyImg.alt || 'Product image', mediaId: '' });
        }
      }

      if (imageSources.length > 0) {
        let galleryHtml = `
          <div class="tapasva-quick-gallery">
            <div class="tapasva-quick-gallery-main">
              <img id="QuickAddMainImage" src="${imageSources[0].src}" alt="${imageSources[0].alt}" loading="eager" />
            </div>
        `;

        if (imageSources.length > 1) {
          galleryHtml += `
            <div class="tapasva-quick-thumbs-wrapper">
              <button type="button" class="tapasva-thumb-nav-btn tapasva-thumb-prev" aria-label="Previous image">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
              </button>
              <div class="tapasva-quick-thumbs-scroll">
          `;

          imageSources.forEach((img, idx) => {
            galleryHtml += `
              <button type="button" class="tapasva-thumb-item ${idx === 0 ? 'is-active' : ''}" data-src="${img.src}" data-index="${idx}" aria-label="Image ${idx + 1}">
                <img src="${img.src}" alt="${img.alt}" />
              </button>
            `;
          });

          galleryHtml += `
              </div>
              <button type="button" class="tapasva-thumb-nav-btn tapasva-thumb-next" aria-label="Next image">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
              </button>
            </div>
          `;
        }

        galleryHtml += `</div>`;
        mediaWrapper.innerHTML = galleryHtml;

        // Fully working image slider and thumbnail switcher
        const mainImg = mediaWrapper.querySelector('#QuickAddMainImage');
        const thumbs = Array.from(mediaWrapper.querySelectorAll('.tapasva-thumb-item'));
        const thumbsScroll = mediaWrapper.querySelector('.tapasva-quick-thumbs-scroll');
        const prevBtn = mediaWrapper.querySelector('.tapasva-thumb-prev');
        const nextBtn = mediaWrapper.querySelector('.tapasva-thumb-next');

        let activeIndex = 0;

        const goToImage = (index) => {
          if (!thumbs.length) return;
          if (index < 0) index = thumbs.length - 1;
          if (index >= thumbs.length) index = 0;
          activeIndex = index;

          thumbs.forEach((t, i) => {
            t.classList.toggle('is-active', i === activeIndex);
          });

          const currentThumb = thumbs[activeIndex];
          if (currentThumb && mainImg) {
            mainImg.src = currentThumb.dataset.src;
          }

          if (thumbsScroll && currentThumb) {
            const scrollTarget = currentThumb.offsetLeft - (thumbsScroll.offsetWidth / 2) + (currentThumb.offsetWidth / 2);
            thumbsScroll.scrollTo({ left: Math.max(0, scrollTarget), behavior: 'smooth' });
          }
        };

        thumbs.forEach((thumb, idx) => {
          thumb.addEventListener('click', (e) => {
            e.preventDefault();
            goToImage(idx);
          });
        });

        if (prevBtn) {
          prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            goToImage(activeIndex - 1);
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            goToImage(activeIndex + 1);
          });
        }
      }
    }

    buildEyebrowAndBadges() {
      const titleElem = this.modalContent.querySelector('.product__title');
      if (titleElem && !this.modalContent.querySelector('.tapasva-quick-eyebrow')) {
        const eyebrow = document.createElement('div');
        eyebrow.className = 'tapasva-quick-eyebrow';
        eyebrow.textContent = 'TAPASVA RITUALS';
        titleElem.parentNode.insertBefore(eyebrow, titleElem);
      }

      // Format Price & Discount and ensure permanent Tax Notice
      const priceWrapper = this.modalContent.querySelector('.price-wrapper') || this.modalContent.querySelector('.price');
      if (priceWrapper) {
        const updatePriceAndBadges = () => {
          const priceElem = this.modalContent.querySelector('.price');
          if (!priceElem) return;

          // Remove any raw internal tax notices inside price element
          priceElem.querySelectorAll('.product__tax, .tax-note, small, .price__tax-note').forEach((el) => el.remove());

          // Deduplicate and format discount badge
          const existingBadges = Array.from(priceElem.querySelectorAll('.badge, .price__badge-sale, .tapasva-discount-pill'));
          if (existingBadges.length > 1) {
            existingBadges.slice(1).forEach((b) => b.remove());
            existingBadges[0].className = 'tapasva-discount-pill';
          } else if (existingBadges.length === 1) {
            existingBadges[0].className = 'tapasva-discount-pill';
          } else {
            const regElem = priceElem.querySelector('s.price-item--regular');
            const saleElem = priceElem.querySelector('.price-item--sale') || priceElem.querySelector('.price-item--last');
            if (regElem && saleElem) {
              const regText = regElem.textContent.replace(/[^0-9.]/g, '');
              const saleText = saleElem.textContent.replace(/[^0-9.]/g, '');
              const regVal = parseFloat(regText);
              const saleVal = parseFloat(saleText);
              if (regVal > saleVal) {
                const percent = Math.round(((regVal - saleVal) / regVal) * 100);
                if (percent > 0) {
                  const badge = document.createElement('span');
                  badge.className = 'tapasva-discount-pill';
                  badge.textContent = `${percent}% OFF`;
                  priceElem.appendChild(badge);
                }
              }
            }
          }

          // Ensure permanent Tax line right below the price container
          let taxNote = this.modalContent.querySelector('.tapasva-quick-tax-note');
          if (!taxNote) {
            taxNote = document.createElement('div');
            taxNote.className = 'tapasva-quick-tax-note';
            taxNote.textContent = 'Tax included. Shipping calculated at checkout.';
            priceWrapper.parentNode.insertBefore(taxNote, priceWrapper.nextSibling);
          }
        };

        updatePriceAndBadges();

        // Observe dynamic AJAX price replacements on variant switch
        if (!this.priceObserver) {
          this.priceObserver = new MutationObserver(() => {
            updatePriceAndBadges();
          });
          this.priceObserver.observe(priceWrapper, { childList: true, subtree: true });
        }
      }

      // Add Variants label
      const variantPicker = this.modalContent.querySelector('variant-radios, variant-selects');
      if (variantPicker) {
        const formLabels = variantPicker.querySelectorAll('.form__label');
        formLabels.forEach((label) => {
          if (!label.textContent.includes(':')) {
            label.textContent = label.textContent.trim() + ' :';
          }
        });
      }
    }

    buildActionButtons() {
      // Ensure quantity and wishlist have Quantity : label
      const topRow = this.modalContent.querySelector('.product-form__top-row');
      if (topRow && !this.modalContent.querySelector('.tapasva-qty-label')) {
        const qtyLabel = document.createElement('span');
        qtyLabel.className = 'tapasva-qty-label';
        qtyLabel.textContent = 'Quantity :';
        topRow.insertBefore(qtyLabel, topRow.firstChild);
      }

      // Ensure exactly ONE cart icon inside Add to Cart button
      const atcBtn = this.modalContent.querySelector('button.product-form__submit');
      if (atcBtn) {
        // Remove any injected or duplicate cart icons so exactly one icon remains
        const allIcons = Array.from(atcBtn.querySelectorAll('.product-form__cart-icon, .tapasva-atc-cart-icon, svg:not(.spinner)'));
        if (allIcons.length > 1) {
          allIcons.slice(1).forEach((ic) => ic.remove());
        }
      }

      // Ensure BUY IT NOW button is present side-by-side with tight 12px gap
      const actionRow = this.modalContent.querySelector('.product-form__action-row');
      if (actionRow) {
        // Clean out any hidden shopify dynamic payment containers in between
        actionRow.querySelectorAll('.product-form__buy-now, .shopify-payment-button').forEach((el) => el.remove());

        let buyNowBtn = actionRow.querySelector('.tapasva-quick-buynow-btn');
        if (!buyNowBtn) {
          buyNowBtn = document.createElement('button');
          buyNowBtn.type = 'button';
          buyNowBtn.className = 'tapasva-quick-buynow-btn';
          buyNowBtn.innerHTML = `
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" stroke="none">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
            </svg>
            <span>BUY IT NOW</span>
          `;
          actionRow.appendChild(buyNowBtn);
        }
      }
    }

    buildTrustAndRating() {
      const actionRow = this.modalContent.querySelector('.product-form__buttons');
      if (!actionRow) return;

      // Remove any unwanted rating pills
      this.modalContent.querySelectorAll('.tapasva-quick-rating-pill').forEach((el) => el.remove());

      // Trust Badges Card (100% Ayurvedic | Handcrafted | Fast Delivery)
      if (!this.modalContent.querySelector('.tapasva-quick-trust-card')) {
        const trustCard = document.createElement('div');
        trustCard.className = 'tapasva-quick-trust-card';
        trustCard.innerHTML = `
          <div class="tapasva-quick-trust-item">
            <div class="tapasva-trust-icon-wrap">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5A1B0B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                <polyline points="9 12 11 14 15 10"></polyline>
              </svg>
            </div>
            <div class="tapasva-quick-trust-text">
              <span class="tapasva-trust-title">100% Ayurvedic</span>
              <span class="tapasva-trust-sub">Safe & Natural</span>
            </div>
          </div>
          <div class="tapasva-trust-divider"></div>
          <div class="tapasva-quick-trust-item">
            <div class="tapasva-trust-icon-wrap">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5A1B0B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path>
                <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
              </svg>
            </div>
            <div class="tapasva-quick-trust-text">
              <span class="tapasva-trust-title">Handcrafted</span>
              <span class="tapasva-trust-sub">With Care</span>
            </div>
          </div>
          <div class="tapasva-trust-divider"></div>
          <div class="tapasva-quick-trust-item">
            <div class="tapasva-trust-icon-wrap">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5A1B0B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="1" y="3" width="15" height="13" rx="2"></rect>
                <polygon points="16 8 20 8 23 11 23 16 16 16 8"></polygon>
                <circle cx="5.5" cy="18.5" r="2.5"></circle>
                <circle cx="18.5" cy="18.5" r="2.5"></circle>
              </svg>
            </div>
            <div class="tapasva-quick-trust-text">
              <span class="tapasva-trust-title">Fast Delivery</span>
              <span class="tapasva-trust-sub">3-5 Days</span>
            </div>
          </div>
        `;
        actionRow.appendChild(trustCard);
      }
    }

    setupBuyNow() {
      const buyNowBtn = this.modalContent.querySelector('.tapasva-quick-buynow-btn');
      if (!buyNowBtn) return;

      buyNowBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const idInput = this.modalContent.querySelector('input[name="id"]');
        const qtyInput = this.modalContent.querySelector('input[name="quantity"], .quantity__input');
        const variantId = idInput ? idInput.value : null;
        const quantity = qtyInput ? qtyInput.value : 1;

        if (variantId) {
          buyNowBtn.disabled = true;
          buyNowBtn.style.opacity = '0.7';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: parseInt(quantity, 10) || 1 }] })
          })
            .then(() => {
              window.location.href = '/checkout';
            })
            .catch(() => {
              window.location.href = `/cart/${variantId}:${quantity}`;
            });
        }
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios, variant-selects');
      if (!variantPicker) return;
      variantPicker.setAttribute('data-update-url', 'false');

      // Update main image on variant change if variant has attached media
      variantPicker.addEventListener('change', () => {
        setTimeout(() => {
          this.buildEyebrowAndBadges();
          const activeThumb = this.modalContent.querySelector('.tapasva-thumb-item.is-active');
          const mainImg = this.modalContent.querySelector('#QuickAddMainImage');
          if (activeThumb && mainImg) {
            mainImg.src = activeThumb.dataset.src;
          }
        }, 150);
      });
    }
  });
}

